import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import Row from '@ui/elements/SectionRow/NestedRow'
import CollapsibleSectionRow from '@ui/elements/SectionRow/CollapsibleSectionRow'
import Chip from '@ui/elements/Chip'
import { ChipProps } from '@ui/elements/Chip/types'
import { colors } from '@ui/colors'
import { SectionProps } from '../types'

type Props = SectionProps

const chipProps: ChipProps = {
  styleContainer: {
    borderColor: colors.black25,
  },
  styleText: {
    color: colors.black50,
  },
}

export default function FrameSection({ data }: Props) {
  const { t } = useTranslation(['order', 'frame'])
  const header = 'order:details.sections.frame.header'
  const label = 'order:details.labels'
  // const SH = t('common:sh')
  const FH = t('common:fh')
  const EXT = t('common:ext')

  return (
    <CollapsibleSectionRow
      icon="eye-glass2"
      title={t(`${header}.title`)}
      desc={t(`${header}.desc`)}
    >
      <Row
        icon="hash"
        title={t(`${label}.id`)}
        texts={[data.frame.id.toString()]}
      />
      <Row
        icon="tag"
        title={t(`${label}.code`)}
        texts={[data.frame.default_code]}
      />
      <Row
        icon="badge-tm"
        title={t(`${label}.brand`)}
        texts={[data.frame.attributes.fbrand]}
      />
      <Row
        icon="category"
        title={t(`${label}.category`)}
        texts={[data.frame.attributes.fcatalog]}
      />
      <Row
        icon="stack-2"
        title={t(`${label}.collection`)}
        texts={[data.frame.attributes.fcollection]}
      />
      <Row
        icon="palette"
        title={t(`${label}.color`)}
        texts={[data.frame.attributes.fcolor]}
      />
      {/* <Row
        icon="arrows-maximize"
        title={t(`${label}.size`)}
        texts={[data.frame.size.toString()]}
      /> */}
      <Row
        icon="ruler-measure-2"
        title={t(`${label}.fh`)}
        body={
          <View className="flex flex-row items-center justify-end gap-2">
            <Chip
              label={`${FH} R`}
              value={(data.config.r_fh || 0).toString()}
              {...chipProps}
            />
            <Chip
              label={`${FH} L`}
              value={(data.config.l_fh || 0).toString()}
              {...chipProps}
            />
          </View>
        }
      />
      <Row
        icon="dimensions"
        title={t(`${label}.extend`)}
        body={
          <View className="flex flex-row items-center justify-end gap-2">
            <Chip
              label={`${EXT} X`}
              value={(data.config.refraction.x_ext || 0).toString()}
              {...chipProps}
            />
            <Chip
              label={`${EXT} Y`}
              value={(data.config.refraction.y_ext || 0).toString()}
              {...chipProps}
            />
          </View>
        }
      />
      {/*
      <Row
        last
        icon="arrow-autofit-height"
        title={t(`${label}.sh`)}
        body={
          <>
            <Chip
              label={`${SH} R`}
              value={(data.config.r_sh || 0).toString()}
              {...chipProps}
            />
            <Chip
              label={`${SH} L`}
              value={(data.config.l_sh || 0).toString()}
              {...chipProps}
            />
          </>
        }
      />
      */}
      <Row
        icon="truck"
        title={t(`${label}.stock`)}
        texts={[
          t(
            `frame:stock.source.options.${
              data.config.frame_from_stock ? 'local' : 'global'
            }.label`
          ),
        ]}
      />
      <Row
        last
        icon="pencil"
        title={t(`${label}.inventory`)}
        texts={[data.config.inventory_no]}
      />
    </CollapsibleSectionRow>
  )
}
